
import React from "react";
import TabelaPaginada from "../components/TabelaPaginada";
import { mensagemErro, mensagemSucesso } from "../components/toastr";
import Card from "../components/card";
import ClipLoader from "react-spinners/ClipLoader";
import EmpresasRecuperacaoJudicialService from "../app/service/empresasRecuperacaoJudicialService";
import { BlinkBlur, ThreeDot } from "react-loading-indicators";

class EmpresasRecuperacaoJudicial extends React.Component {
  state = {
    empresas: [],
    paginaAtual: 1,
    registrosPorPagina: 20,
    totalPaginas: 1,
    loading: false,
    loadingRelatorio: false,
    disabled: false,
  };

  constructor() {
    super();
    this.service = new EmpresasRecuperacaoJudicialService();
  }

  componentDidMount() {
    this.buscarEmpresas();
  }

  buscarEmpresas = () => {
    this.setState({ loading: true });

    this.service
      .listarEmpresasEmRecuperacaoJudicial()
      .then((response) => {
        const empresas = response.data || [];
        const totalPaginas = Math.ceil(
          empresas.length / this.state.registrosPorPagina
        );

        this.setState({
          empresas,
          totalPaginas,
          loading: false,
        });
      })
      .catch(() => {
        mensagemErro("Erro ao buscar empresas em Recuperação Judicial");
        this.setState({ loading: false });
      });
  };

  gerarRelatorio = async () => {
    this.setState({ loadingRelatorio: true, disabled:true });

    this.service
      .gerarRelatorioEmRecuperacaoJudicial()
      .then(() => {
        mensagemSucesso("Relatório gerado com sucesso!");
      })
      .catch(() => {
        mensagemErro("Erro ao gerar relatório.");
      })
      .finally( () => {
        this.setState({ loadingRelatorio: false, disabled:false });
      });
  };

  mudarPagina = (pagina) => {
    if (pagina > 0 && pagina <= this.state.totalPaginas) {
      this.setState({ paginaAtual: pagina });
    }
  };

  render() {
    const { empresas, paginaAtual, registrosPorPagina, totalPaginas, loading, loadingRelatorio } =
      this.state;

    // Paginação dos dados
    const indiceInicial = (paginaAtual - 1) * registrosPorPagina;
    const dadosPaginados = empresas.slice(
      indiceInicial,
      indiceInicial + registrosPorPagina
    );

    // Configuração das colunas da tabela
    const colunas = [
      { label: "NIRE", campo: "nrNire" },
      { label: "CNPJ", campo: "nrCgc" },
      { label: "NOME DA EMPRESA", campo: "nomeEmpresa" },
    ];

    return (
      <Card title="Empresas em Recuperação Judicial">
        {loading ? (
          <div className="d-flex justify-content-center my-5">
            <BlinkBlur loading={loading} color="#65AE67" size={80} text="Buscando empresas...." textColor="#212529" /> 
            {/*<ClipLoader size={50} color={"#28a745"} loading={loading} />*/}
          </div>
        ) : (
          <>
            {/* Container com altura fixa e scroll */}
            <div style={{ maxHeight: "350px", overflowY: "auto", marginTop:"20px"}}>
              <TabelaPaginada
                dados={dadosPaginados}
                colunas={colunas}
                paginaAtual={paginaAtual}
                totalPaginas={totalPaginas}
                empresas = {empresas}
                onPageChange={this.mudarPagina}
              />
            </div>
            
             {/* Rodapé - Total Empresas Falidas */}
             <span className="" style={{padding: "5px", marginTop:"5px", display: "block", textAlign:"center"}}> 🏦 Total de Empresas ........ :  {empresas.length} </span>
            
            {/* Rodapé com botão */}
            <div className="d-flex justify-content-end align-items-center gap-2 mt-1">
                {loadingRelatorio && ( <ThreeDot loading={loadingRelatorio} color="#65AE67" size={20} text="Gerando relatório..." textColor="#212529" /> )}
                 {/*<ClipLoader loading={this.state.loadingRelatorio} size={50} />*/}
                 <br/>
                <button
                    onClick={this.gerarRelatorio}
                    className="btn btn-success"
                    disabled={loadingRelatorio}
                    ><i className="pi pi-undo"> </i>
                    Exportar
                </button>
            </div>
          </>
        )}
        
      </Card>
    );
  }
}

export default EmpresasRecuperacaoJudicial;